import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import { css } from '@emotion/css'

import { FlxStyleModule, FlxThemeModule, FlxWrapperStyleDirective } from '@flowx/angular-theme'
import { HeaderTemplateConfig } from '@flowx/core-sdk'
import { PositionStyle, computePosition } from '@flowx/core-theme'

import { FlxTreeNodeComponent } from '../../renderer/tree-node/tree-node.component'

@Component({
  selector: 'flx-header',
  hostDirectives: [
    { directive: FlxWrapperStyleDirective, inputs: ['flxWrapperStyle: templateConfig'] },
  ],
  imports: [CommonModule, FlxTreeNodeComponent, FlxThemeModule, FlxStyleModule],
  templateUrl: './flx-header.component.html',
  styleUrl: './flx-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClassName()',
  },
})
export class FlxHeaderComponent {
  templateConfig = input.required<HeaderTemplateConfig>()

  displayOptions = computed(() => this.templateConfig().displayOptions)
  flowxProps = computed(() => this.displayOptions().flowxProps)
  style = computed(() => this.displayOptions().style)

  hostClassName = computed(() =>
    ['flx-header', this.displayOptions().className, css(this.positionStyle())]
      .filter(Boolean)
      .join(' ')
  )

  positionStyle = computed(() => {
    const position = this.style()?.position
    return position?.positionType === 'fixed'
      ? { position: 'sticky', top: '0', zIndex: '3' }
      : computePosition((position ?? {}) as PositionStyle)
  })
}
